export const formatNumber = (number: number | null, commaFormat: boolean=false, roundDecimalPlaces: number=0) => {
  if (roundDecimalPlaces && number) {
    number = Math.round(number * Math.pow(10, roundDecimalPlaces)) / Math.pow(10, roundDecimalPlaces)
  }

  const value = number || '-'
  return commaFormat ? value.toLocaleString() : value.toString()
}
